import type { FC, ReactNode } from 'react';

import { ConfirmParticipantOperationModal } from './ConfirmParticipantOperationModal';

export const DROP_CO_BUYER_ERROR_TITLE = 'Remove Co-Buyer Failed';
export const DROP_CO_BUYER_ERROR_MESSAGE = 'The co-buyer could not be removed. Please try again.';

type DropCoBuyerModalProps = {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    isDropping: boolean;
    hasFailed: boolean;
    reminder?: ReactNode;
};

export const DropCoBuyerModal: FC<DropCoBuyerModalProps> = ({ show, onConfirm, onCancel, isDropping, hasFailed, reminder }) => (
    <ConfirmParticipantOperationModal
        show={show}
        onConfirm={onConfirm}
        onCancel={onCancel}
        isPending={isDropping}
        hasFailed={hasFailed}
        id="drop-cobuyer-modal"
        dataTestIdPrefix="drop-cobuyer"
        header="Remove Co-Buyer"
        prompt="Are you sure you want to remove this co-buyer?"
        confirmLabel="Remove Co-Buyer"
        errorTitle={DROP_CO_BUYER_ERROR_TITLE}
        errorMessage={DROP_CO_BUYER_ERROR_MESSAGE}
        reminder={reminder}
    />
);
